import { render, staticRenderFns } from "./CommitteeGroupListItem.vue?vue&type=template&id=28c117a2"
import script from "./CommitteeGroupListItem.vue?vue&type=script&lang=js"
export * from "./CommitteeGroupListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports